"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseIcon = void 0;
const CloseIcon = _ref => {
  let {
    iconColor
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      cursor: "pointer",
      color: iconColor
    }
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    role: "img",
    "aria-label": "close icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.665 2.682l-2.35-2.35L12 9.649 2.682.332l-2.35 2.35 9.317 9.317-9.317 9.316 2.35 2.35 9.317-9.316 9.316 9.316 2.35-2.35L14.35 12l9.316-9.317z"
  })));
};
exports.CloseIcon = CloseIcon;